import React from "react"
import dayjs from "utils/dates"

// components
import { Descriptions, Typography, Tag } from "antd"
import { EuroCircleFilled } from "@ant-design/icons"
import OrderItemList from "./OrderItemList"
import OrderStatusTag from "./OrderStatusTag"

// store
// (language no longer needed directly)

// i18n
import { useTranslation } from "react-i18next"

// utils
import { formatAsCurrency } from "utils/currency"

const OrderDescription = ({ order }) => {
  const { t } = useTranslation()

  return (
    <Descriptions
      size="small"
      bordered
      column={3}
      items={[
        {
          key: "status",
          span: 3,
          label: t("status"),
          children: <OrderStatusTag order={order} />,
        },

        {
          key: "3",
          span: 3,
          label: t("service"),
          children:
            order.type === "delivery"
              ? t("delivery")
              : order.type === "eat-in"
              ? t("eat_in")
              : t("pickup"),
        },

        {
          key: "1",
          span: 3,
          label: t("order_date"),
          children: dayjs(order.created_at.toDate()).format(
            "D MMMM YYYY HH:mm"
          ),
        },
        {
          key: "2",
          span: 3,
          label: t("payment_method_label"),
          children:
            order.payment_method === "resto"
              ? order.type === "delivery"
                ? t("cash_on_delivery_text")
                : order.type === "eat-in"
                ? t("cash_at_table")
                : t("payment_on_pickup_text")
              : order.payment_method === "card"
              ? t("online_payment")
              : t("unknown_status"),
        },
        {
          key: "3",
          span: 3,
          label: t("payment_status"),
          children: (
            <Tag
              icon={<EuroCircleFilled />}
              color={order.payment_status === "success" ? "success" : "warning"}
            >
              {order.payment_status === "success" ? t("paid") : t("unpaid")}
            </Tag>
          ),
        },
        ...(order.type === "delivery"
          ? [
              {
                key: "delivery_address",
                span: 3,
                label: t("delivery_address"),
                children: (
                  <Typography.Paragraph>
                    {order.street} <br />
                    {order.zip} {order.city}
                  </Typography.Paragraph>
                ),
              },
              {
                key: "extra_distance_costs",
                span: 3,
                label: t("delivery_costs"),
                children: formatAsCurrency(order.extra_distance_costs),
              },
              {
                key: "delivery_distance",
                span: 3,
                label: t("delivery_distance"),
                children: `${order.distance.toFixed(2).replace(".", ",")} km`,
              },
            ]
          : []),

        {
          key: "subtotal",
          span: 3,
          label: t("subtotal_label"),
          children: formatAsCurrency(order.subtotal || 0),
        },

        {
          key: "total",
          span: 3,
          label: t("total_label"),
          children: formatAsCurrency(order.total || 0),
        },

        {
          key: "discount",
          span: 3,
          label: t("discounts"),
          children: formatAsCurrency(order.pickup_discounts || 0),
        },

        {
          key: "fee",
          span: 3,
          label: t("service_fee_label"),
          children: formatAsCurrency(order.app_fee || 0),
        },

        {
          key: "vat",
          span: 3,
          label: t("vat"),
          children: formatAsCurrency(order.vat || 0),
        },

        {
          key: "10",
          label: t("order"),
          span: 3,
          children: <OrderItemList items={order.items} />,
        },

        ...(order.status === "accepted" || order.status === "finished"
          ? [
              {
                key: "eta",
                span: 3,
                label: t("estimated_processing_time_label"),
                children: `${order.eta} ${t("minutes")}`,
              },
            ]
          : []),
      ]}
    />
  )
}

export default OrderDescription
